import { Controller } from "@hotwired/stimulus"

// This controller is used to trigger an event when the result of an email verification is rendered on the screen.
export default class extends Controller {
  static get values() {
    return { action: String }
  }

  connect() {
    if (["success", "block"].includes(this.actionValue)) {
      this.dispatch(this.actionValue, { detail: { element: this.element } })
    }
  }
}
